
import React, { useRef, useState, useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { DataService } from './Shared/DataService';
import { Cookies } from './Shared/Cookies';
import { ErrorMsg } from './Shared/ErrorMsg';
import './style/login.css'

const Login: React.FC = () => {
  const navigate = useNavigate();
  const ds = new DataService();
  const CK = new Cookies();

  const userName = useRef<HTMLInputElement>(null);
  const userPassword = useRef<HTMLInputElement>(null);
  const [errorTime, seterrorTime] = useState(0);
  const [Reset, setReset] = useState(false);

  const [displayForm, setDisplayForm] = useState<boolean>(false);
  
  const loginValidation = () => {
    let name = userName?.current?.value;
    let password = userPassword?.current?.value;
    if (name == "" || password == "" || name == undefined || password == undefined) {
      alert("Please fill in user name and password");
      return;
    }

    ds.Get("User", "UserLogin", { userId: name, password: password })
      .then(response => response.json())
      .then(data => { handleResponse(data) });
  }

  const handleResponse = (result: any) => {
    if (result['UserName'] != null || result['UserID'] > 0) {
      localStorage.setItem('isLogged', "true")
      localStorage.setItem("userID", result['UserID']);
      localStorage.setItem("userName", result['UserName']);
      localStorage.setItem("userType", result['TypeID']);
      localStorage.setItem("userFirstName", result['UserFirstName']);
      localStorage.setItem("userLastName", result['UserLastName']);


      // CK.Login();
      // CK.Set("userID", result['UserID']);
      // CK.Set("userName", result['UserName']);
      // CK.Set("userType", result['TypeID']);
      // CK.Set("userFirstName", result['UserFirstName']);
      // CK.Set("userLastName", result['UserLastName']);

      return navigate('/Dashboard');
    } else {
      alert(ErrorMsg.LoginFail);
      seterrorTime(prev => prev + 1);
    }
  }

  const handleOnKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter')
      loginValidation();
    else
      return;
  }

  const forgotPassword = () => {
    seterrorTime(0);
    setReset(true);
  }

  const resetLogin = () => {
    let name = userName?.current?.value;
    ds.Get("User", "CheckUserByName", { UserName: name })
      .then(response => response.json())
      .then(data => { handleResetResponse(data) });
  }

  const handleResetResponse = (result: any) => {
    if (result.length > 0) {
      let ID = result[0].user_ID;
      let name = userName?.current?.value;
      let password = userPassword?.current?.value;

      let data = {
        UserName: name,
        UserPassword: password,
        UserID: ID,
        ModifiedID: ID
      }

      // CK.Set("userID", ID);
      // CK.Set("userName", name!);

      localStorage.setItem("userID", result['UserID']);
      localStorage.setItem("userName", result['UserName']);

      UpdateUser(data);
    } else {
      alert(ErrorMsg.UserNotExist);
    }
  }

  const UpdateUser = (Data: object) => {
    ds.Post("User", "UpdateUserInfo", Data)
      .then(response => response.json())
      .then(data => {
        if (data['UserID'] > 0) {
          alert("User Infomation is updated");

          localStorage.setItem('isLogged', "true")
          localStorage.setItem("userType", data['TypeID']);
          localStorage.setItem("userFirstName", data['UserFirstName']);
          localStorage.setItem("userLastName", data['UserLastName']);

          // CK.Login();
          // CK.Set("userType", data['TypeID']);
          return navigate('/Dashboard');
        } else {
          alert("Fail to update");
        }
      });
  }



  return (
    <div className="Login d-flex flex-column justify-content-center align-items-center" >
      <div className='bg-dark bg-opacity-75 w-100 text-center p-3'>
        <div>
          <img style={{ width: '15%' }} src={require('./img/logo.png')} />
        </div>
        <div className='mt-3'>
          <div>
            Winz Solutions Ticket System
          </div>

        
          <button type="button" className="btn btn-light LoginButton  mt-3"
            style={{ display: displayForm == true ? 'none' : 'inline-block' }}
            onClick={() => { setDisplayForm(true) }}>
            Sign In
          </button>

          <div className='mt-4 d-flex  justify-content-center'>
            <div className='LoginForm' style={{ height: displayForm == true ? '28vh' : 0 }}>
              <div>
                <input ref={userName} type="text" placeholder='User Name' className="form-control mb-3" onKeyPress={(e) => { handleOnKeyPress(e) }} />
                <input ref={userPassword} type="password" placeholder='Password' className="form-control" onKeyPress={(e) => { handleOnKeyPress(e) }} />
              </div>
              <div style={{ marginTop: 15 }}>
                {!Reset && 
                <button style={{ width:'100%' }} type="button" className="btn btn-light LoginButton" onClick={() => { loginValidation() }}>Login</button>
                }

                 {Reset &&  <button style={{ width:'100%'}} type="button" className="btn btn-lgiht ResetButton" onClick={() => { resetLogin() }}>Reset</button>}

                { errorTime>=3 &&<button style={{ width:'100%' }} type="button" className="btn btn-light ForgotPasswordButton mt-1" onClick={() => { forgotPassword() }}>Forgot Password?</button>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  )
}

export default Login;